import { SubmitHandler } from 'react-hook-form';
import { useNavigate, useParams } from "react-router";
import useUpdateRestaurant from '../../hooks/Restaurant/useUpdateRestaurant'
import RestaurantForm from "./RestaurantForm";
import Spinner from '../../components/ui/spinner';
import useRestaurant from '../../hooks/Restaurant/useRestaurant'
import { useToast } from "../../context/ToastContext";
import { isString } from 'lodash';

import type { RestaurantVariables } from '../../types/restaurantTypes';

const RestaurantEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const toast = useToast();
  const { restaurant, loading, error } = useRestaurant(id, {
    fetchPolicy: "network-only",
    refetchOnMount: false,
  });
  const { updateRestaurant } = useUpdateRestaurant({
    onCompleted: (restaurantUpdated) => {
      if (restaurantUpdated) { 
        navigate('/restaurants')
        toast.success(`Restaurant ${restaurantUpdated.name} updated successfully`);
      }
    },
    onError: (err) => {
      if (err) return toast.error(String(err)); 
    }
  });

  const onSubmit: SubmitHandler<RestaurantVariables>  = async formValues => {
    if (isString(formValues.address)) {
      return toast.error('Please select address from list.');
    }
    try {
      await updateRestaurant({
        id: id!,
        phone: formValues.phone,
        website: formValues.website,
        wifi: formValues.wifi,
        name: formValues.name,
        image: formValues.image instanceof FileList ? formValues.image[0] : formValues.image,
        address: {
          fullAddress: formValues.address.fullAddress,
          latitude: formValues.address.latitude,
          longitude: formValues.address.longitude,
          street: formValues.address.street,
          house: formValues.address.house,
          countryCode: formValues.address.countryCode,
          mapboxId: formValues.address.mapboxId
        }
      });
    } catch (err) {
      console.error("restaurant update error (component):", err);
      // toast
    }
  };
  
  if (loading) return <Spinner />;
  if (error) return <p>Error: {error.message}</p>;

  return <RestaurantForm onSubmit={onSubmit} restaurant={restaurant} />
}

export default RestaurantEdit;
